export enum Protocols {
    HTTP = 'http:',
    HTTPS = 'https:',
    WS = 'ws:',
    WSS = 'wss:',
    STOMP = 'stomp:',
    AMQP = 'amqp:',
    MQTT = 'mqtt:'
}
